// src/layouts/AuthLayout.jsx

import React, { Suspense } from 'react';
import {
  Box,
  Container,
  CircularProgress,
} from '@mui/material';

const AuthLayout = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        // Uncomment to use theme background instead of gradient:
        // background: (theme) => theme.palette.background.default,
        backgroundImage: `linear-gradient(
          to right bottom,
          #253453,
          #2b3754,
          #313a54,
          #363e55,
          #3b4155,
          #454a5d,
          #505466,
          #5a5e6e,
          #6c7081,
          #7f8395,
          #9297a9,
          #a6abbd
        )`,
      }}
    >
      <Container>
        {/*
          We wrap children in Suspense so any lazy-loaded page (e.g. Login)
          can show a spinner rather than crash. If you switch to synchronous
          imports for Login, you can remove this Suspense wrapper later.
        */}
        <Suspense
          fallback={
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
              <CircularProgress />
            </Box>
          }
        >
          {children}
        </Suspense>
      </Container>
    </Box>
  );
};

export default AuthLayout;
